import * as React from 'react';

import { IDocument, IPostcardImage } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface IPostcardImageBackEditorFormProps {
  document: IDocument;
  postcardImagesList: IPostcardImage[];
  onPostcardImageChangeBack(image: any): void;
  className: string;
}

export default class PostcardImageBackEditorForm extends React.Component<IPostcardImageBackEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.postcardImagesList.filter(image => image.side === "Back").map((image, key) => (
          <div key={image.id} className="rowStepTwo">
            <Radio
              checked={(this.props.document.postcardImageBack && this.props.document.postcardImageBack.id === image.id)!}
              onChange={() => this.props.onPostcardImageChangeBack(image)}
            >
              <div className="image-box">
                <img alt={image.name} src={image.image_src} />
                <span>{image.name}</span>
              </div>
            </Radio>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/PostcardImageBackEditorForm.tsx